import { Routes } from '@angular/router';
import { authGuard } from './core/guard/guard.guard';


export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    // redirectTo: '/closed',
    // loadComponent: () => import('./features/closed/closed.component').then(m => m.ClosedComponent)
    loadComponent: () => import('./features/home/page/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'product/:slug',
    loadComponent: () => import('./features/product/page/product-home/product-home.component').then((m) => m.ProductHomeComponent),
  },
  {
    path: 'category/:slug',
    loadComponent: () => import('./features/category/page/category-home/category-home.component').then((m) => m.CategoryHomeComponent),
  },
  {
    path: 'calculadora',
    loadComponent: () => import('./features/calculadora-msi/calculadora-msi.component').then((m) => m.CalculadoraMsiComponent),
  },
  {
    path: 'pinpad',
    loadComponent: () => import('./features/pinpad/page/home-pinpad/home-pinpad.component').then((m) => m.HomePinpadComponent),
  },
  {
    path: 'account',
    loadComponent: () => import('./features/account/account/account.component').then((m) => m.AccountComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'profile',
        loadComponent: () => import('./features/account/components/profile/profile.component').then((m) => m.ProfileComponent),
      },
      {
        path: 'settings',
        loadComponent: () => import('./features/account/components/settings/settings.component').then((m) => m.SettingsComponent),
      },
      {
        path: 'orders',
        loadComponent: () => import('./features/account/components/orders/orders.component').then((m) => m.OrdersComponent),
      },
      {
        path: 'cashback',
        loadComponent: () => import('./features/account/components/cashback/cashback.component').then((m) => m.CashbackComponent),
      },
    ],
  },
  {
    path: 'closed',
    loadComponent: () => import('./features/closed/closed.component').then((m) => m.ClosedComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./features/account/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'sale',
    loadComponent: () => import('./features/conventions/conventions-home/conventions-home.component').then((m) => m.ConventionsHomeComponent),
    children: [
      {
        path: 'scan',
        loadComponent: () => import('./features/conventions/components/scan-products/scan-products.component').then((m) => m.ScanProductsComponent),
      },
    ],
  },
  // {
  //   path: '**',
  //   redirectTo: '',
  // }
  // {
  //     path: 'clip',
  //     loadComponent: () => import('./shared/components/clip/clip.component').then(m => m.ClipComponent)
  // }
];
